import React from 'react';
import { HORIZONTAL_BANNER_SIZE } from '../types';

interface ISubtitleProps {
  size?: HORIZONTAL_BANNER_SIZE;
  children: React.ReactNode;
}

export const Subtitle: React.FC<ISubtitleProps> = ({
  size = HORIZONTAL_BANNER_SIZE.RESPONSIVE,
  children,
}) => {
  const isResponsive = size === HORIZONTAL_BANNER_SIZE.RESPONSIVE;

  return (
    <span
      className={`tw-lf-body-regular-sm ${
        isResponsive ? 'desktop:tw-lf-body-regular-md' : ''
      }`}
    >
      {children}
    </span>
  );
};
